import { render, staticRenderFns } from "./DownloadOpmerkingen.vue?vue&type=template&id=29df81dd"
import script from "./DownloadOpmerkingen.vue?vue&type=script&lang=js"
export * from "./DownloadOpmerkingen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports